import { Component } from '@ecs/Component';

export type DockPhase = 'docked' | 'undocking' | 'launching' | 'gone';

/** A roster ship in its mothership berth, or on its way out during a launch. */
export class Docked implements Component {
  readonly type = 'Docked';
  public phase: DockPhase = 'docked';
  public frame = 0;
  /** Frames to wait before undocking, so a launch leaves in sequence */
  public delay = 0;

  constructor(
    public berth: number,
    public bobPhase: number = 0
  ) {}
}
